import React from 'react';
import { Form, Input, Button } from 'antd';
import { ServiceSearchReq } from '../../../request/service.request';
import { useService } from '../service.hook';

export const ServiceFilterComponent: React.FC = () => {
    const [form] = Form.useForm();
    const { fetchServiceList, updateLoading, serviceSearchReq  } = useService()

    const handleOk = () => {
        form.validateFields().then(values => {
            updateLoading(true);
            const _serviceSearchReq = {
                ...serviceSearchReq,
                name: values["name"],
                pageNumber: 1,
                itemsPerPage: 10
            } as ServiceSearchReq
            fetchServiceList(_serviceSearchReq, onSuccess, onFailure)
        });
    };

    const onSuccess = () => {
        updateLoading(false);
    }

    const onFailure = () => {
        updateLoading(false);
    }

    return (
        <Form form={form} layout="inline">
            <Form.Item
                name="name"
                style={{ minWidth: 124 }}
                initialValue={serviceSearchReq.name}
            >
                <Input placeholder='Name' />
            </Form.Item>

            <Form.Item style={{ minWidth: 124 }}>
                <Button type="primary" htmlType="submit"
                    onClick={handleOk}>
                    Search
                </Button>
            </Form.Item>
        </Form>
    );
}
